var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEdit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-reply",
    transform: "translate(-307.000000, -563.000000)",
    fill: "#BBBBBB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.60421,51.0441972 C290.424775,50.86476 290.338339,50.6369714 290.306113,50.4025969 C290.229943,50.4143156 290.153045,50.4253078 290.074671,50.4253078 C289.674037,50.4253078 289.29759,50.2685581 289.014141,49.9851289 C288.730692,49.7009498 288.574695,49.325224 288.574695,48.9245841 C288.574695,48.8513421 288.585687,48.7803032 288.595929,48.7092408 C288.353495,48.6762877 288.129389,48.5700692 287.95361,48.3942883 C287.936759,48.3774368 287.9309,48.3547259 287.915525,48.3364212 L287,52 L290.653991,51.0852127 C290.637889,51.0705643 290.619585,51.0595721 290.60421,51.0441972 L290.60421,51.0441972 Z M295.378051,42.5605653 L289.544406,48.3942883 C289.251442,48.6865299 289.252168,49.1618649 289.544406,49.4548331 C289.83737,49.7478013 290.311972,49.7492778 290.605663,49.4541065 L296.439308,43.6214851 L295.378051,42.5605653 Z M288.483876,47.3337435 C288.337393,47.4802276 288.337393,47.7175318 288.483876,47.8640159 C288.630358,48.0105 288.867659,48.0105 289.014141,47.8640159 L294.848512,42.0306445 L294.318247,41.5003721 L288.483876,47.3337435 Z M291.135929,49.9851055 C290.989446,50.1315896 290.989446,50.3688938 291.135929,50.5153779 C291.282411,50.6625885 291.519712,50.6625885 291.666194,50.5153779 L297.500588,44.6823815 L296.969597,44.1517341 L291.135929,49.9851055 Z M298.561119,43.6214617 L298.030854,44.1521091 L294.848512,40.9700997 L295.378777,40.4394523 C295.964706,39.8535159 296.914637,39.8535159 297.500565,40.4394523 L298.561096,41.5003721 C299.146298,42.0859569 299.146298,43.0355253 298.561119,43.6214617 L298.561119,43.6214617 Z",
    id: "icEdit"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/icEdit.fdc3a76317e265e70d05407a9133f509.svg";
export { ForwardRef as ReactComponent };